import { ErrorResponse } from "./ErrorResponse";

export class ErrorsResponse {
  errors: ErrorResponse[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(errorsJson: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.errors = errorsJson ? errorsJson.map((e: any) => new ErrorResponse(e.id, e.message)) : []
  }
}